export const GET_CREDIT_ACCOUNT_VIEW_FETCHER_NAME = 'OrderConvertOnAccount/GET_CREDIT_ACCOUNT_VIEW'
export const CHECK_CREDIT_ACCOUNT_FETCHER_NAME = 'OrderConvertOnAccount/CHECK_CREDIT_ACCOUNT'
export const GET_DEBIT_ACCOUNT_VIEW_FETCHER_NAME = 'OrderConvertOnAccount/GET_DEBIT_ACCOUNT_VIEW'
export const CHECK_DEBIT_ACCOUNT_FETCHER_NAME = 'OrderConvertOnAccount/CHECK_DEBIT_ACCOUNT'
export const FORM_NAME = 'OrderConvertOnAccount'
